import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@morpho-org/ui-v6/server';
const TotalMyDepositLoading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="h-[52.8px] w-[140px] rounded-[20px] max-md:h-[44px]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default TotalMyDepositLoading;